<div class="table">
  <div class="table-height">
    <div class="table-box">
      <table>
        <thead>
          <tr>
            @for (propriete of proprietesAffichees; track i; let i = $index) {
              <th [title]="propriete.libelleAffiche | translate">
                <div style="cursor: pointer;">
                  <span (click)="sortBy(propriete, i)">{{ propriete.libelleAffiche | translate }}
                    <i class="fas"
                      [class.fa-sort-down]="arrowSort()[i] && i === activeSort()"
                      [class.fa-sort-up]="!arrowSort()[i] || i !== activeSort()"></i>
                  </span>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (apiKey of tabApiKeys(); track apiKey.siteApiKeyId) {
            <tr (click)="selectApiKey($event, apiKey)" style="cursor: pointer;">
              <td style="padding-left: 10px;">{{ apiKey.name }}</td>
              <td>{{ apiKey.keyPrefix }}</td>
              <td>{{ apiKey.createdAt | date:'short' }}</td>
              <td>{{ apiKey.expiresAt ? (apiKey.expiresAt | date:'short') : '-' }}</td>
              <td>
                <span class="badge" [ngClass]="apiKey.isActive ? 'badge-success' : 'badge-danger'">
                  {{ apiKey.isActive ? ('GLOBAL.ACTIVE' | translate) : ('GLOBAL.INACTIVE' | translate) }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="footer">
    <button class="btn btn-primary" (click)="ouvrirModaleAdd()">
      <i class="fas fa-plus" style="padding-right: 5px;"></i>{{ 'MINE_TRACKER.CREATE' | translate }}
    </button>
  </div>
</div>
